import http from '../../plugins/axios';

export default {
    queryWalletReconciliationList(data) {
        return http.get({
            url: '/admin/wallet/balance/list',
            data
        })
    },

    createWalletReconciliation(data) {
        return http.post({
            url: `/admin/wallet/balance/create`,
            data,
            dataType: 'form'
        });
    },

    getAllSupportCoin() {
        return http.get({
            url: '/admin/coin/allDisplay'
        });
    },
}
